import React from "react";
import { useGetWatchlistEntry } from "@rentablo/api/apiv1";
import { GainLossStatistics } from "./GainLossStatistics";

interface Props {
  watchlistEntryId: number;
}

export const GainLossStatisticsLoader = ({ watchlistEntryId }: Props) => {
  const { data: watchlistEntry, isFetching: isWatchlistEntryLoading } =
    useGetWatchlistEntry({ id: watchlistEntryId });

  return (
    <GainLossStatistics
      isFetching={isWatchlistEntryLoading}
      watchlistEntry={watchlistEntry}
    />
  );
};
